export default __webpack_public_path__ + "static/media/ch_2.55a449c8.mp3";